import UserSvg from 'assets/user.svg'
import { Button } from 'component/Button'
import { Img } from 'component/Image'
import { Space } from 'component/Space'
import { useLatestCallback } from 'hook/useLatestCallback'
import { observer } from 'mobx-react-lite'
import { controller } from 'store/controller'
import { store } from 'store/store'
import css from './ProfileButton.module.scss'

export const ProfileButton = observer(() => {
  const { picture, saving } = store.profile ?? {}
  const disabled = !!saving

  const onEdit = useLatestCallback(() => {
    if (store.screen === 'profile') {
      if (store.profile?.type === 'simple') {
        store.profile.simple.stage = 'profile'
        if (!store.profile.identity_id) {
          store.identities.deleteProfile(store.profile)
          store.identities.reset()
        }
      }
    }

    const hasSavedProfiles = store.identities.profiles.some(it => !!it.identity_id)
    if (hasSavedProfiles) controller.openProfile()
    else controller.openCreateProfile()
    store.manualOpenProfile = true
  })

  return (
    <Button
      className={css.button}
      text
      compact
      square
      disabled={disabled}
      action={onEdit}
    >
      <Space className={css.image} center>
        {picture && <Img src={picture} />}
        {!picture && <UserSvg width={20} height={20} />}
      </Space>
    </Button>
  )
})
